import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=ec3df714"
import script from "@/views/Users/Teacher/Profile.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Teacher/Profile.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Teacher/profile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports